import { Typography } from "@mui/material";
import { ReactChild, ReactFragment, ReactPortal } from "react";
export const PageTitle = (props: { children: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined; }) => {
  return (
    <Typography variant="h4" component="p" sx={{ my: 2 }}>
      {props.children}
    </Typography>
  );
};
